export default __webpack_public_path__ + "static/media/build-black-18dp.4cd3ee93.svg";